const c = {
  id: "Pick6",
  name: "Pick 6",
  style: {
    colorPrimary: "#007ac2"
  }
};
export {
  c as default
};
